import ShippingRepository from './ShippingRepository';

export * from './ShippingRepository';

export default ShippingRepository;
